import {
  Box,
  FormControl,
  InputAdornment,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  TextField,
} from '@mui/material';
import Switch from '@mui/material/Switch';
import Chip from '@mui/material/Chip';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getApi, sessionExpired } from '../../../../_redux/_apiHelpers/_apihelper';
import {
  getCountriesAsync,
  getCountriesStartReducer,
  getListVendorsAsync,
} from '../../../../_redux/_services/JobPostingSlice';
import { updateLoader } from '../../../../_redux/LoaderSlice';
import { updateSnackbar } from '../../../../_redux/SnackbarSlice';

import { getUserDetails, GetUserId } from '../../../../_utilities/getUserInfo';
const initialSnackbar = { type: '', message: '' };

const JobpostingDetailsPortals = ({
  componentType,
  isPortalData = false,
  onReceiveHandler,
  data,
  flatFee,
  flatFeeCountryId,
  vendors = [],
  updateHandler,
  updateCountryHandler,
  onReceiveData,
}) => {
  const [selectedCurrency, setSelectedCurrency] = useState('');
  const [countriesList, setCountriesList] = useState([]);
  const [vendorsList, setVendorsList] = useState([]);
  const [selectedVendors, setSelectedVendors] = useState([]);
  const countriesRes = useSelector((state) => state.GetCountries.data);
  const vendorsRes = useSelector((state) => state.GetListVendors.data);
  const [portals, setPortals] = useState([]);
  const [jobPortaldata, setJobPortaldata] = useState([]);
  const [isSegments, setIsSegments] = useState(true);

  const label = { inputProps: { 'aria-label': 'Switch demo' } };
  const dispatch = useDispatch();

  const onChangePlatformHandler = (e, item, isSegments) => {
    onReceiveHandler(e, item, isSegments);
  };

  const getData = async (id) => {
    try {
      dispatch(updateLoader(true));
      dispatch(updateSnackbar(initialSnackbar));
      const res = await getApi(
        `/mgmt/customers/jobBoard`,
        process.env.REACT_APP_USE_MANAGEMENT
      );
      const jsonData = res.data;
      if (jsonData.Data?.jobBoard.length > 0) {
        setJobPortaldata(jsonData.Data?.jobBoard[0]);
        console.log(jsonData.Data?.jobBoard[0]);
      }
      if (jsonData.Data?.segments.length === 0) {
        setIsSegments(false);
      }
      dispatch(updateLoader(false));
    } catch (error) {
      if (error?.response?.status === 405 || error?.response?.status === 406) {
        return sessionExpired(error?.response?.data?.message);
      }
    }
  };

  useEffect(() => {
    async function init() {
      if (data.length > 0) {
        let userDetails = getUserDetails();
        let portals = JSON.parse(userDetails.portals);
        let portalIds = portals[0].portal;
        // console.log(portalIds);
        let portalArray = [];
        data.forEach((list) => {
          if (portalIds.includes(list.id.toString())) {
            portalArray.push(list);
          }
          if (jobPortaldata.isJobPortal === 1 && list.id === 5) {
            portalArray.push(list);
          }
          setPortals(portalArray);
        });
      }
    }
    init();
  }, [data, jobPortaldata]);

  useEffect(() => {
    if (portals.length === 0) {
      updateHandler(true, 'portalData');
    } else {
      updateHandler(false, 'portalData');
    }
  }, [portals]);

  const onChangeHandler = (value, type) => {
    if (type === 'flatFee') {
      const regex = /^[0-9]*$/;
      if (regex.test(value)) {
        updateHandler(value, 'flatFee');
      }
    } else if (type === 'vendor') {
      setSelectedVendors(value);
      updateHandler(value, 'vendor');
    }
  };

  useEffect(() => {
    async function init() {
      if (!countriesRes) {
        dispatch(getCountriesAsync());
      }
      let userInfo = await GetUserId();
      getData(userInfo);
      dispatch(getListVendorsAsync(userInfo));
    }
    init();
  }, []);

  useEffect(() => {
    if (countriesRes && countriesRes.length > 0) {
      let ListofCountries = JSON.parse(JSON.stringify(countriesRes));
      console.log(ListofCountries);
      setCountriesList(ListofCountries);
      getCountriesStartReducer({});
    }
  }, [countriesRes]);

  useEffect(() => {
    if (vendorsRes && vendorsRes.length > 0) {
      let ListofVendors = JSON.parse(JSON.stringify(vendorsRes));
      let activeVendors = ListofVendors.filter((x) => x?.vendorStatus === 1);
      setVendorsList([{ id: 0, vendorName: "All" }, ...activeVendors]);
    }
  }, [vendorsRes]);

  useEffect(() => {
    if (vendors && vendors.length > 0 && vendorsList.length > 0) {
      let selectedVendors = vendorsList.filter((x) => vendors.includes(x.id));
      setSelectedVendors(selectedVendors);
    }
  }, [vendors, vendorsList]);

  const onCurrencyTypeChangeHandler = (e) => {
    setSelectedCurrency(e.target.value);
    updateCountryHandler(e.target.value.id);
  };

   const onVendorChangeHandler = (event) => {
    const {
      target: { value },
    } = event;

    let newValue = typeof value === "string" ? value.split(",") : value;

    // Handle "All" logic
    const allOption = vendorsList.find((v) => v.id === 0);
    const wasAllSelected = selectedVendors.find((v) => v.id === 0);
    const isAllNowSelected = newValue.find((v) => v.id === 0);

    if (isAllNowSelected && !wasAllSelected) {
      // "All" was just selected, clear others
      newValue = [allOption];
    } else if (isAllNowSelected && newValue.length > 1) {
      // "All" was already selected and another one was added, remove "All"
      newValue = newValue.filter((v) => v.id !== 0);
    }

    setSelectedVendors(newValue);
    updateHandler(newValue, "vendor");
  };

  useEffect(() => {
    if (countriesList.length > 0 && flatFeeCountryId) {
      let countryId =
        typeof flatFeeCountryId === 'string'
          ? parseInt(flatFeeCountryId)
          : flatFeeCountryId;
      const country = countriesList.find((x) => parseInt(x.id) === countryId);
      setSelectedCurrency(country);
    }
  }, [flatFeeCountryId, countriesList]);

  useEffect(() => {
    if (isPortalData === true) {
      onReceiveData(null, true, 'portals');
    }
  }, [isPortalData]);

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };

  return (
    <>
      <div className="portalsSection">
        {portals.length > 0 ? (
          <h4 className="subHeading" style={{ marginBottom: '60px' }}>
            Please select the portals to display the job posting
          </h4>
        ) : (
          <h4 className="subHeading" style={{ marginBottom: '60px' }}>
            No portals found. Please contact admin to add portals options.
          </h4>
        )}
        {portals &&
          portals.map((item) => (
            <>
              <p key={item.id}>
                {item.title}{' '}
                <Switch
                  {...label}
                  checked={item.checked}
                  disabled={componentType !== 'View' ? false : true}
                  onChange={(e) => onChangePlatformHandler(e, item, isSegments)}
                  className={item.checked ? 'activeBtn' : 'inActiveBtn'}
                />
              </p>
              {item.name === 'CSPortal' && parseInt(item.value) === 1 && (
                <div style={{ width: '23%' }}>
                  <TextField
                    className="boldlabel"
                    id="outlined-basic"
                    variant="outlined"
                    autoComplete="off"
                    label="Flat Fee"
                    style={{ width: '100%' }}
                    name="flatFee"
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <Select
                            id="outlined-basic"
                            className="innerDropdown"
                            value={selectedCurrency}
                            size="small"
                            name="image"
                            onChange={onCurrencyTypeChangeHandler}
                            disabled={componentType !== 'View' ? false : true}
                          >
                            {countriesList &&
                              countriesList.map((name) => (
                                <MenuItem
                                  className="selectOptions"
                                  key={name.id}
                                  value={name}
                                >
                                  <img
                                    src={`${process.env.REACT_APP_IMG_BASEPATH}/${name.image}`}
                                    alt={name.countryName}
                                    width="20px"
                                    style={{ paddingRight: '7px' }}
                                  />
                                  {name?.currencyName}
                                </MenuItem>
                              ))}
                          </Select>
                          {selectedCurrency &&
                            Object.keys(selectedCurrency).length > 0 && (
                              <span>{selectedCurrency.currency}</span>
                            )}
                        </InputAdornment>
                      ),
                    }}
                    disabled={componentType !== 'View' ? false : true}
                    value={parseInt(flatFee) === 0 ? '' : flatFee}
                    onChange={(e) => onChangeHandler(e.target.value, 'flatFee')}
                  />
                </div>
              )}
              {item.name === 'VSPortal' && parseInt(item.value) === 1 && (
                <div style={{ width: '23%' }}>
                  <FormControl sx={{ m: 1, width: 300 }}>
                    <InputLabel
                      id="demo-multiple-chip-label"
                      className="boldSelectlabel"
                      shrink={true}
                    >
                      Select vendors&nbsp;
                    </InputLabel>
                    <Select
                      labelId="demo-multiple-chip-label"
                      id="demo-multiple-chip"
                      style={{ width: '86%' }}
                      multiple
                      displayEmpty
                      value={selectedVendors || []}
                      disabled={componentType !== 'View' ? false : true}
                      onChange={onVendorChangeHandler}
                      input={
                        <OutlinedInput
                          id="select-multiple-chip"
                          label="Select vendors"
                        />
                      }
                      renderValue={(selected) => {
                        if (selected.length === 0) {
                          return vendorsList.length > 1 ? (
                            <em>Select vendors</em>
                          ) : (
                            <em>All</em>
                          );
                        }
                        if (selected.find((v) => v.id === 0)) {
                          return <em>All</em>;
                        }
                        return (
                          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                            {selected.map((value) => (
                              <Chip key={value.id} label={value.vendorName} />
                            ))}
                          </Box>
                        );
                      }}
                      MenuProps={MenuProps}
                    >
                      {vendorsList.map((item) => (
                        <MenuItem
                          key={item.id}
                          value={item}
                        >
                          {item.vendorName}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </div>
              )}
            </>
          ))}
      </div>
    </>
  );
};
export default React.memo(JobpostingDetailsPortals);
